import { render, staticRenderFns } from "./Passwords.vue?vue&type=template&id=471765e0"
import script from "./Passwords.vue?vue&type=script&lang=js"
export * from "./Passwords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports